import { cookies } from '@/shared/lib/cookies';
import _ from 'lodash';
import generateLinkConfig from './env';

/**
 * Builds the runtime Amplify configuration of the Biocare portal. Spreads the environment's AWS exports, overrides the OAuth sign-in and sign-out redirects with the localhost-aware link, and nests an Auth block whose cookie storage is scoped to localhost or the environment domain with a one-year strict cookie that is secure only off localhost.
 *
 * @returns Amplify configuration object with OAuth redirects and cookie storage applied.
 */
const updatedAwsConfig = () => {
  const LINK_CONFIG = generateLinkConfig();
  return {
    ...LINK_CONFIG.AWS_CONFIG,
    oauth: {
      ...LINK_CONFIG.AWS_CONFIG.oauth,
      redirectSignIn: LINK_CONFIG.LINK_REDIRECT_AWS,
      redirectSignOut: LINK_CONFIG.LINK_REDIRECT_AWS,
    },
    Auth: {
      ...LINK_CONFIG.AWS_CONFIG,
      cookieStorage: {
        domain: cookies.getDomain(),
        path: '/',
        expires: 365,
        sameSite: 'strict',
        secure: !_.includes(window.location.hostname, 'localhost'),
      },
    },
  };
};

export default updatedAwsConfig;
